var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: _vm.classes },
    [
      _vm.noneInfo && _vm.none
        ? _c(
            "li",
            {
              class: ["none", { clickable: _vm.clickable }],
              on: {
                click: function($event) {
                  return _vm.$emit("editItem")
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.noneInfo) + "\n\t")]
          )
        : !_vm.none
        ? _vm._l(_vm.sortedItems, function(item, i) {
            return _c("characteristic-selected-items-item", {
              key: item.item ? item.item.id : "item-" + i,
              attrs: {
                level: 0,
                item: item,
                selected: _vm.selected,
                "show-experience": _vm.showExperience,
                "show-additions": _vm.showAdditions,
                "icon-path": _vm.iconPath,
                "specificities-provider": _vm.specificitiesProvider,
                "label-appendix-provider": _vm.labelAppendixProvider,
                deletable: _vm.deletable,
                "with-edit-button": _vm.withEditButton,
                "no-children-appendix": _vm.noChildrenAppendix,
                "label-type": _vm.labelType,
                styling: _vm.styling,
                clickable: _vm.clickable
              },
              on: {
                delete: function($event) {
                  return _vm.$emit("deleteItem", $event)
                },
                edit: function($event) {
                  return _vm.$emit("editItem", $event)
                }
              }
            })
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }